import React from 'react';

import { List, Item, Info, RightArrow } from './styles';

interface Props {
  list: Array<{
    name: string;
    show: boolean;
    onClick: (event: React.SyntheticEvent) => void;
  }>;
}

export const NavigationList = ({ list }: Props) => (
  <List>
    {list.map(
      ({ name, show, onClick }) =>
        show && (
          <Item key={name} onClick={onClick}>
            <Info>
              <Item.Name>{name}</Item.Name>
            </Info>
            <RightArrow>
              <img src="/corporate/images/right-arrow.svg" alt="back-arrow" />
            </RightArrow>
          </Item>
        ),
    )}
  </List>
);

export default NavigationList;
